import React from "react";

export function Sponsors() {
  const [sponsors, setSponsors] = React.useState();
  let cochairs = "Loading",
    secondcentuary,
    plat,
    gold,
    goldplus,
    silver,
    silverplus,
    bronzeplus,
    bronze,
    civicimpact;

  React.useEffect(function () {
    fetch(
      "https://script.googleusercontent.com/macros/echo?user_content_key=AwUWOEvb8jKMNs9HXQKhCQn3ywtaqJOCF7_vEcrZRyW9pgg56a8vq36DmV2sVPRptLAsJoo28RVdr1xeGBmGd97qi8Cn6KANm5_BxDlH2jW0nuo2oDemN9CCS2h10ox_1xSncGQajx_ryfhECjZEnOYvYP6Ptx0ez9tp9ggfn7BQgl9Laixpw_ajh_bmn5W8fUUx1mfPNb4z1PIOC3hB65dDHobs_dHo3Jrg7g6LZcwAGgqSNLznTQ&lib=MXvJ4nGr42jiIzQczXtkwVlRjwUM6HP_Z"
    )
      .then((res) => res.json())
      .then((data) => setSponsors(data));
  }, []);

  if (sponsors) {
    cochairs = sponsors.data[0].map((spon) => <div>{spon}</div>);
    secondcentuary = sponsors.data[1].map((spon) => <div>{spon}</div>);
    plat = sponsors.data[2].map((spon) => <div>{spon}</div>);
    gold = sponsors.data[3].map((spon) => <div>{spon}</div>);
    silver = sponsors.data[4].map((spon) => <div>{spon}</div>);
    bronze = sponsors.data[5].map((spon) => <div>{spon}</div>);
    civicimpact = sponsors.data[6].map((spon) => <div>{spon}</div>);
    console.log(civicimpact.length);
  }

  return (
    <div className="text-center sponsors pb-5">
      <div className="pb-3">
        {" "}
        <h3 className="">Co-chairs</h3> {cochairs}
      </div>
      <div className="pb-3">
        {" "}
        <h3 className="">Second Century</h3> {secondcentuary}
      </div>
      <div className="pb-3">
        {" "}
        <h3 className="">Platinum</h3> {plat}
      </div>

      

      <div className="container">
        <div className="row">
          <div className="col">
            <div className="pb-3">
              <h3>Gold Sponsors</h3>
              {gold}
            </div>
          </div>
          <div className="col">
            <div className="pb-3">
              <h3>Silver Sponsors</h3>
              {silver}
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="pb-3">
              <h3>Bronze Sponsors</h3>
              {bronze}
            </div>
          </div>
          {civicimpact == false ? (
        ""
      ) : (
        <div className="col">
        <div className="pb-3">
        <h3>Civic Impact Alliance Sponsors</h3> {civicimpact}

        </div>
      </div>
      )}
        </div>
      </div>




    </div>
  );
}
